<template>
    <div>
        <v-container>
            <v-row class="ma-0">
                <v-col cols="12" class=" text-right">
                <p class="headline">Laporan Test</p>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="12">
                    <v-data-table
                        :headers="dessertHeaders"
                        :items="desserts"
                        :single-expand="singleExpand"
                        :expanded.sync="expanded"
                        item-key="name"
                        show-expand
                        class="elevation-1"
                    >
                        <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>Expandable Table</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        </template>
                        <template v-slot:expanded-item="{ item }">
                        <td>
                            <table>
                                <tr v-for="row in item.paket" :key="row.index">
                                    <td>{{ row.text }} </td>
                                </tr>
                            </table>
                        </td>
                        <td>{{ item.name }} </td>
                        <td>{{ item.name }} </td>
                        <td>{{ item.name }} </td>
                        <td>{{ item.name }} </td>
                        <td>{{ item.name }} </td>
                        <td></td>

                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
// const axios = require("axios").default;
// const apiUrl = process.env.VUE_APP_ROOT_API;
// import { getValueItem } from "./../../lib/viewLib";
// import { tahunAnggaran } from './../../lib/viewLib'

export default{
    data() {
        return {
            expanded: [],
        singleExpand: true,
        dessertHeaders: [
          {
            text: 'Dessert (100g serving)',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'Calories', value: 'calories' },
          { text: 'Fat (g)', value: 'fat' },
          { text: 'Carbs (g)', value: 'carbs' },
          { text: 'Protein (g)', value: 'protein' },
          { text: 'Iron (%)', value: 'iron' },
          { text: '', value: 'data-table-expand' },
        ],
        desserts: [
          {
            name: 'Frozen Yogurt',
            calories: 159,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
            iron: '1%',
            paket: [
                {text: 'AA'},
                {text: 'AB'},
                {text: 'AC'},
            ]
          },
          {
            name: 'Ice cream sandwich',
            calories: 237,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
            iron: '1%',
            paket: [
                {text: 'AA'},
                {text: 'AB'},
                {text: 'AC'},
            ]
          },
          {
            name: 'Eclair',
            calories: 262,
            fat: 16.0,
            carbs: 23,
            protein: 6.0,
            iron: '7%',
            paket: [
                {text: 'AA'},
                {text: 'AB'},
                {text: 'AC'},
            ]
          },
          {
            name: 'Cupcake',
            calories: 305,
            fat: 3.7,
            carbs: 67,
            protein: 4.3,
            iron: '8%',
            paket: [
                {text: 'AA'},
                {text: 'AB'},
                {text: 'AC'},
            ]
          },
          {
            name: 'Gingerbread',
            calories: 356,
            fat: 16.0,
            carbs: 49,
            protein: 3.9,
            iron: '16%',
            paket: [
                {text: 'AA'},
                {text: 'AB'},
                {text: 'AC'},
            ]
          },
          {
            name: 'Jelly bean',
            calories: 375,
            fat: 0.0,
            carbs: 94,
            protein: 0.0,
            iron: '0%',
            paket: [
                {text: 'AA'},
                {text: 'AB'},
                {text: 'AC'},
            ]
          },
          {
            name: 'Lollipop',
            calories: 392,
            fat: 0.2,
            carbs: 98,
            protein: 0,
            iron: '2%',
          },
          {
            name: 'Honeycomb',
            calories: 408,
            fat: 3.2,
            carbs: 87,
            protein: 6.5,
            iron: '45%',
            paket: [
                {text: 'AA'},
                {text: 'AB'},
                {text: 'AC'},
            ]
          },
          {
            name: 'Donut',
            calories: 452,
            fat: 25.0,
            carbs: 51,
            protein: 4.9,
            iron: '22%',
            paket: [
                {text: 'AA'},
                {text: 'AB'},
                {text: 'AC'},
            ]
          },
          {
            name: 'KitKat',
            calories: 518,
            fat: 26.0,
            carbs: 65,
            protein: 7,
            iron: '6%',
            paket: [
                {text: 'AA'},
                {text: 'AB'},
                {text: 'AC'},
            ]
          },
        ],
        }
    },
    created() {
        
    },
    methods: {
        
    }
}
</script>

<style scoped>
    .container{
        max-width: 100vw;
        padding:0px;
    }

</style>